import request from '@/utils/request.js'
import main from '@/main'

const basePath = '/Function/Gateway/';

const state = {};

const mutations = {};

const actions = {

  SyncTeam({commit}, view) {
    return request.PromiseCall(basePath, 'SyncTeam', view);
  },
  SyncTeamOrder({commit}, view) {
    return request.PromiseCall(basePath, 'SyncTeamOrder', view);
  },

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Function/Gateway/index.js